const PENDING_PASSWORD_SETUP_STORAGE_KEY = 'bustly:pending_password_setup';

function getSessionStorage(): Storage | null {
    if (typeof window === 'undefined') return null;
    return window.sessionStorage;
}

export function markPendingPasswordSetup() {
    try {
        getSessionStorage()?.setItem(PENDING_PASSWORD_SETUP_STORAGE_KEY, '1');
    } catch {
        // Ignore storage failures; the auth form still owns the visible step.
    }
}

export function clearPendingPasswordSetup() {
    try {
        getSessionStorage()?.removeItem(PENDING_PASSWORD_SETUP_STORAGE_KEY);
    } catch {
        // Ignore storage failures.
    }
}

export function hasPendingPasswordSetup(): boolean {
    try {
        return getSessionStorage()?.getItem(PENDING_PASSWORD_SETUP_STORAGE_KEY) === '1';
    } catch {
        return false;
    }
}

export function isAuthPasswordSetupRoute(pathname: string): boolean {
    return pathname === '/auth'
        || pathname.startsWith('/auth/')
        || pathname === '/admin/auth'
        || pathname.startsWith('/admin/auth/');
}
